/**
 * Converts a `data:` URL (e.g. a canvas-captured signature) into a `File` so it
 * can be sent as multipart form data. Used both by the online submit path and by
 * the offline sync engine when it replays a deferred `signature.attach`.
 */
export const dataUrlToFile = async (dataUrl: string, filename: string): Promise<File> => {
  const response = await fetch(dataUrl);
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type || 'image/png' });
};
